// extracted by mini-css-extract-plugin
export var card = "_qa-0";
export var content = "_qa-2";
export var details = "_qa-3";
export var icon = "_qa-1";
export var iconBlue = "_qa-5";
export var iconBrand = "_qa-4";
export var iconGrayBlue = "_qa-6";
export var iconGreen = "_qa-7";
export var iconIndigo = "_qa-8";
export var iconOrange = "_qa-9";
export var iconPurple = "_qa-a";
export var iconRed = "_qa-b";
export var iconWarning = "_qa-c";